import { Products } from "../components/Products";

export default function Fundraising() {
  return (
    <main className="min-h-[70vh] pt-10 pb-16">
      <section className="px-4 md:px-8 max-w-6xl mx-auto text-center mb-8">
        <h1 className="text-4xl md:text-6xl font-extrabold uppercase text-[#47c0d2] drop-shadow-sm mb-3">
          Fundraising
        </h1>
        <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
          Support your community — these products are part of our fundraising collection.
        </p>
      </section>

      <section className="px-4 md:px-8">
        <Products page="fr" />
      </section>
    </main>
  );
}
